import { fetchAll, fetchJson } from "./fetch";
import provider from "./DataProvider";

export const data = {
    fetchAll,
    fetchJson,
    provider
}